import React = require("react");
import { BookHighlight } from "./AdviceState";

type AdviceDetailsProps = BookHighlight & {
  close: () => void
}

export const AdviceDetails = (props: AdviceDetailsProps) => {
  const { book: { title, author, cover, description }, availability, close } = props

  const [touchStart, setTouchStart] = React.useState(0);
  const [touchEnd, setTouchEnd] = React.useState(0);

  let handleTouchStart = (e) => setTouchStart(e.targetTouches[0].clientX)

  let handleTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX)

  let handleTouchEnd = () => {
    if (touchStart - touchEnd < -150) {
      close();
    }
  }

  let closeDetails = (e) => {
    if (e.currentTarget === e.target) {
      close()
    }
  }

  let avInfo = <></>
  switch (availability) {
    case 'somewhere':
    case 'none':
      avInfo = <div className="details__scan-to-hold">
        <div className="scan-to-hold__cta">Reserveer</div>
        <img className="scan-to-hold__qr-code" src={props.qrDataUrl} />
      </div>
      break;
    case 'elsewhere':
      avInfo = <div className="details__scan-to-hold">
        <div className="scan-to-hold__cta">Reserveer</div>
        <div className="scan-to-hold__available-elsewhere">Deze titel is beschikbaar op andere vestigingen.</div>
        <img className="scan-to-hold__qr-code" src={props.qrDataUrl} />
      </div>
      break;
    case 'here':
      avInfo = <div>
        <div>Deze titel is hier aanwezig:</div>
        <div>{props.location}</div>
        {props.code && <div>{props.code}</div>}
      </div>
  }


  return <div className="bookresult details__overlay"
    onClick={closeDetails}
    onTouchStart={handleTouchStart}
    onTouchMove={handleTouchMove}
    onTouchEnd={handleTouchEnd}
  >
    <div className="bookresult details__content">
      <div className="details__top">
        <div className="bookcover__block">
          <div className="bookresult bookcover bookcover--large">
            <div className="bookresult__cover bookcover__inner">
              <img className="bookresult__image bookcover__image" src={`${cover}size=195`} srcSet={`${cover}size=195 1x, ${cover}size=390 2x`} alt={`${title} - ${author}`} loading="lazy" width="195" height="310" />
            </div>
          </div>
        </div>
        <div className="description__block">
          <div>
            <h2 className="description__title">{title}</h2>
            <h4 className="description__author">{author}</h4>
          </div>
          <div className="description__contents">{avInfo}</div>
        </div>
      </div>

      {description && <div className="details__bottom">{description}</div>}
    </div>
  </div>
}